exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".data-sheet-content__image[data-v-129347a7]{margin:0 0 1rem}.data-sheet-content__image[data-v-129347a7]  .sf-image{width:100%;max-width:280px;border-radius:4px;overflow:hidden;background:var(--c-light)}.data-sheet-content__image[data-v-129347a7]  .sf-image img{width:100%;height:auto;-o-object-fit:cover;object-fit:cover}.data-sheet-content__description[data-v-129347a7]{margin-bottom:1.25rem;line-height:1.5;color:var(--c-dark-variant)}.data-sheet-content__description[data-v-129347a7]  p:last-child{margin-bottom:0}.data-sheet-content__datasheet-title[data-v-129347a7]{margin:0 0 0.75rem}\n", ""]);

// exports
